module.exports = __webpack_public_path__ + "img/yx2-zh.2b0ae5b7.jpg";